import { render } from "./pku.vue?vue&type=template&id=3fdec062&scoped=true"
import script from "./pku.vue?vue&type=script&lang=js"
export * from "./pku.vue?vue&type=script&lang=js"

import "./pku.vue?vue&type=style&index=0&id=3fdec062&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fdec062"]])

export default __exports__